<template>
  <v-card elevation="0" class="card" width="250px">
    <div class="title">
      <h6 class="no-margin">{{ title }}</h6>
    </div>

    <div class="number">
      <h3 class="no-margin">{{ number }}</h3>
    </div>

    <div class="bar">
      <v-progress-linear
        :color="color ? color : '#ffffff'"
        v-model="numberBar"
        class="bar"
        dark
        height="10"
      >
      </v-progress-linear>
    </div>

    <div class="button">
      <v-btn
        elevation="1"
        class="mx-2 element"
        fab
        x-small
        color="gray-color"
        text
        @click="$emit('find', code)"
      >
        <v-icon dark>
          search
        </v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    code: String,
    color: String,
    number: Number,
    numberBar: Number,
  },

  data: () => ({}),
};
</script>

<style>
.no-margin {
  margin: 0;
}

.title {
  grid-area: title;
  align-self: center;
}

.number {
  grid-area: number;
  align-self: center;
  justify-self: center;
}
.bar {
  grid-area: bar;
  align-self: center;
  justify-self: center;
}

.button {
  grid-area: button;
  align-self: center;
  justify-self: center;
}

*:focus {
  outline: none;
  box-shadow: none;
}

.card {
  padding: 1rem;
  display: grid;
  grid-template:
    'title number'
    'bar button';
  grid-template-columns: 3fr 1fr;
  grid-template-rows: 2fr 2fr;
  justify-items: center;
}

.bar {
  width: 10rem;
}
</style>
